export default "__VITE_ASSET__Dyd7OzNK__"